import { Component, OnInit, Input } from '@angular/core';
import { DATA_PER_PAGE, CANCEL } from './../../../../app.constant';
import { CatalogService } from '@catalog/catalog.service';
import { ToastrService } from 'ngx-toastr';
import { ErrorHandler } from '@root/utils/error-handler.service';

@Component({
  selector: 'app-list-thumbnail',
  templateUrl: './list-thumbnail.component.html',
  styleUrls: ['./list-thumbnail.component.scss']
})
export class ListThumbnailComponent implements OnInit {

  @Input() data: any[];

  @Input() type: string;

  pageSize: number = DATA_PER_PAGE;

  panelMap: { [key: string]: boolean } = {};

  constructor(
    private catalogService: CatalogService,
    private toastr: ToastrService,
    private errorHandler: ErrorHandler
  ) {}

  ngOnInit() {
  }

  public readArticles(type) {
    const obj = {
      type: type ? type : '',
      year: "",
      month: ""
    };

    this.catalogService.readArticles(obj).subscribe(
      (response) => {
        if (response.status === 0) {
          this.data = [...response.data.articles];
        }
      },
      (error) => {}
    );
  }

}
